import store from '../store/'

export default [{
    path: '/makeaclaim',
    name: 'makeaclaim',
    components: { main: () => import(/* webpackChunkName: "makeaclaim" */ '../views/MakeAClaim.vue') },
    meta: {
      checkForUser: true
    },
    redirect: '/makeaclaim/1',
    children: [
      {
        path: '/makeaclaim/1',
        name: 'policylookup',
        beforeEnter (to, from, next) {    
          store.dispatch('resetBeforeMakeAClaim')
          next(next)
        },
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tgaForm/PolicyLookup.vue') }
      },
      {
        path: '/makeaclaim/2',
        name: 'policydetails',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tgaForm/PolicyDetails.vue') }
      },
      {
        path: '/makeaclaim/5',
        name: 'incidenttypes',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tgaForm/IncidentTypes.v2.vue') }
      },
      {
        path: '/makeaclaim/6',
        name: 'aboutYou',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tgaForm/AboutYou.vue') }
      },
      {
        path: '/makeaclaim/8',
        name: 'incidentDetails',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tgaForm/IncidentDetails.v2.vue') }
      },
      {
        path: '/makeaclaim/10',
        name: 'gadgetlist',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tgaForm/gadgets/GadgetList.vue') }
      },
      {
        path: '/makeaclaim/101/:id?',
        name: 'gadgetDetails',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tgaForm/gadgets/GadgetDetails.vue') }
      },
      {
        path: '/makeaclaim/11',
        name: 'supportingDocs',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tgaForm/SupportingDocs.vue') }
      },
      {
        path: '/makeaclaim/13',
        name: 'declartion',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tgaForm/Declaration.v2.vue') }
      },
      {
        path: '/makeaclaim/17',
        name: 'reviewv2',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tgaForm/Review.v2.vue') }
      },
      {
        path: '/makeaclaim/thankyou',
        name: 'thankyou',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tgaForm/ThankYou.v2.vue') }
      },
      {
        path: '/makeaclaim/approved',
        name: 'approved',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tgaForm/ApprovedFastTrack.vue') }
      },
      {
        path: '/makeaclaim/resume',
        name: 'resume',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tgaForm/SavedFormLookup.vue') }
      }
    ]
  },
  {
    path: '/claimsguide',
    name: 'claimsguide',
    components: { main: () => import(/* webpackChunkName: "terms" */ '../views/guide/ClaimsGuideTiga.vue') }
  }]